__turbopack_context__.v({
  "arrowIcon": "AiInRecruitingFutureSection-module__7LuFbq__arrowIcon",
  "futureSection": "AiInRecruitingFutureSection-module__7LuFbq__futureSection",
  "itemDesc": "AiInRecruitingFutureSection-module__7LuFbq__itemDesc",
  "itemLabel": "AiInRecruitingFutureSection-module__7LuFbq__itemLabel",
  "itemText": "AiInRecruitingFutureSection-module__7LuFbq__itemText",
  "listBox": "AiInRecruitingFutureSection-module__7LuFbq__listBox",
  "listItem": "AiInRecruitingFutureSection-module__7LuFbq__listItem",
  "sectionSubtitle": "AiInRecruitingFutureSection-module__7LuFbq__sectionSubtitle",
  "sectionTitle": "AiInRecruitingFutureSection-module__7LuFbq__sectionTitle",
  "trendsLabel": "AiInRecruitingFutureSection-module__7LuFbq__trendsLabel",
});
